<template>
    <v-dialog v-model="$store.state.payroll.entries" fullscreen persistent>
        <v-card class="mb-5">
            <v-container class="container" fluid>
                <v-toolbar dense dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text"
                        >Fuel Expenses Entries</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        left
                        @click="$store.state.payroll.entries = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-toolbar>
                <v-form ref="formAdd" v-model="valid" lazy-validation>
                    <v-row class="justify-center">
                        <v-col sm="12" md="4" lg="3">
                            <v-combobox
                                v-model="comboboxSupplier"
                                placeholder="Select supplier"
                                class="mx-3"
                                label="Supplier"
                                :items="suppliers"
                                :rules="[v => !!v || 'Required']"
                                required
                                :item-text="'Supplier'"
                                :item-value="'OOSupplierId'"
                                auto-select-first
                            ></v-combobox>
                        </v-col>
                        <v-col sm="12" md="4" lg="3">
                            <v-text-field
                                label="Stmt Number"
                                class="mx-3"
                                v-model="stNumber"
                            ></v-text-field>
                        </v-col>
                        <v-col sm="12" md="4" lg="3">
                            <v-text-field
                                label="Stmt Date"
                                class="mx-3"
                                :placeholder="$store.state.placeholder"
                                v-model="stDate"
                                v-mask="'####-##-##'"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <!-- new entry table -->
                    <template>
                        <v-data-table
                            :headers="titles"
                            :items="expensesEntries"
                            :items-per-page="5"
                            class="elevation-1"
                            hide-default-footer
                        >
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>New Entry</v-toolbar-title>
                                    <v-btn
                                        color="success"
                                        icon
                                        @click="loadShifts"
                                        ><v-icon>mdi-reload</v-icon></v-btn
                                    >
                                </v-toolbar>
                            </template>
                            <template v-slot:item.shifts>
                                <v-combobox
                                    placeholder="Select shift"
                                    class="mx-3"
                                    v-model="comboShifts"
                                    :items="shifts"
                                    required
                                    :rules="[v => !!v || 'Required']"
                                    :item-text="'text'"
                                    :item-value="'ShiftDetail'"
                                    auto-select-first
                                    @change="viewDta"
                                >
                                </v-combobox>
                            </template>
                            <template v-slot:item.Date>
                                <v-text-field
                                    v-model="date"
                                    :placeholder="$store.state.placeholder"
                                    v-mask="'####-##-##'"
                                    :rules="dateRules"
                                >
                                </v-text-field>
                            </template>
                            <template v-slot:item.invoiceNo>
                                <v-text-field
                                    v-model="invoiceNo"
                                    :rules="[v => !!v || 'Required']"
                                >
                                </v-text-field>
                            </template>
                            <template v-slot:item.qty>
                                <v-text-field
                                    v-model="qty"
                                    @blur="calculate"
                                    :rules="[
                                        v => !!v || 'Required',
                                        v =>
                                            !isNaN(parseFloat(v)) ||
                                            'Only numbers'
                                    ]"
                                >
                                </v-text-field>
                            </template>
                            <template v-slot:item.gst>
                                <v-text-field
                                    v-model="gst"
                                    :rules="[
                                        v => !!v || 'Required',
                                        v =>
                                            !isNaN(parseFloat(v)) ||
                                            'Only numbers'
                                    ]"
                                >
                                </v-text-field>
                            </template>
                            <template v-slot:item.total>
                                <v-text-field
                                    v-model="total"
                                    :rules="[
                                        v => !!v || 'Required',
                                        v =>
                                            !isNaN(parseFloat(v)) ||
                                            'Only numbers'
                                    ]"
                                >
                                </v-text-field>
                            </template>

                            <template v-slot:item.Province.Province>
                                <v-combobox
                                    placeholder="Select province"
                                    class="mx-3"
                                    v-model="province"
                                    :items="provinces"
                                    required
                                    :rules="[v => !!v || 'Required']"
                                    :item-text="'Province'"
                                    :item-value="'ProvinceAbbr'"
                                    auto-select-first
                                >
                                </v-combobox>
                            </template>
                            <template v-slot:item.actualPrice>
                                <v-text-field
                                    v-model="actualPrice"
                                    :rules="[
                                        v => !!v || 'Required',
                                        v =>
                                            !isNaN(parseFloat(v)) ||
                                            'Only numbers'
                                    ]"
                                >
                                </v-text-field>
                            </template>
                            <template v-slot:item.actualCost>
                                <v-text-field
                                    v-model="actualCost"
                                    :rules="[
                                        v => !!v || 'Required',
                                        v =>
                                            !isNaN(parseFloat(v)) ||
                                            'Only numbers'
                                    ]"
                                >
                                </v-text-field>
                            </template>
                            <template v-slot:item.expenseType>
                                <v-combobox
                                    class="mx-3"
                                    v-model="expenseType"
                                    :items="fuelType"
                                    :item-text="'Type'"
                                    :item-value="'OOExpTypeId'"
                                    :rules="[v => !!v || 'Required']"
                                    auto-select-first
                                ></v-combobox>
                            </template>
                            <template v-slot:item.actions>
                                <v-btn
                                    color="success"
                                    @click="validateFormAdd()"
                                >
                                    Add
                                </v-btn>
                            </template>
                        </v-data-table>
                    </template>
                </v-form>
                <!-- table expenses entries  -->
                <template>
                    <v-data-table
                        :headers="titleEntrys"
                        :items="data"
                        sort-by="calories"
                        class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title
                                    >Fuel Expenses Entries</v-toolbar-title
                                >

                                <v-spacer></v-spacer>
                                <!-- edit entry dialog -->
                                <v-dialog v-model="dialog" max-width="500px">
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline"
                                                >Edit Entry</span
                                            >
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-form
                                                    ref="formEdit"
                                                    v-model="valid"
                                                    lazy-validation
                                                >
                                                    <v-row>
                                                        <v-col cols="8">
                                                            <v-combobox
                                                                placeholder="Select shift"
                                                                v-model="
                                                                    editedItem.text
                                                                "
                                                                :items="shifts"
                                                                required
                                                                :rules="[
                                                                    v =>
                                                                        !!v ||
                                                                        'Required'
                                                                ]"
                                                                @change="
                                                                    changeShift
                                                                "
                                                                :item-text="
                                                                    'text'
                                                                "
                                                                :item-value="
                                                                    'ShiftDetail'
                                                                "
                                                                auto-select-first
                                                            >
                                                            </v-combobox>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-text-field
                                                                v-model="
                                                                    editedItem.Date
                                                                "
                                                                label="Date"
                                                                :rules="[
                                                                    v =>
                                                                        !!v ||
                                                                        'Required'
                                                                ]"
                                                                required
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="6">
                                                            <v-text-field
                                                                v-model="
                                                                    editedItem.invoiceNo
                                                                "
                                                                label="Invoice No."
                                                                :rules="[
                                                                    v =>
                                                                        !!v ||
                                                                        'Required'
                                                                ]"
                                                                required
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-combobox
                                                                class="mx-3"
                                                                :items="
                                                                    fuelType
                                                                "
                                                                v-model="
                                                                    editedItem.expenseType
                                                                "
                                                                :item-text="
                                                                    'Type'
                                                                "
                                                                :item-value="
                                                                    'OOExpTypeId'
                                                                "
                                                                label="Expense Type"
                                                                auto-select-first
                                                                :rules="[
                                                                    v =>
                                                                        !!v ||
                                                                        'Required'
                                                                ]"
                                                                required
                                                            ></v-combobox>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="4">
                                                            <v-text-field
                                                                v-model="
                                                                    editedItem.qty
                                                                "
                                                                @blur="
                                                                    calculateEdt
                                                                "
                                                                label="QTY"
                                                                :rules="[
                                                                    v =>
                                                                        !!v ||
                                                                        'Required',
                                                                    v =>
                                                                        (!isNaN(
                                                                            parseFloat(
                                                                                v
                                                                            )
                                                                        ) &&
                                                                            v >=
                                                                                0) ||
                                                                        'Only numbers'
                                                                ]"
                                                                required
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-text-field
                                                                v-model="
                                                                    editedItem.gst
                                                                "
                                                                label="GST"
                                                                :rules="[
                                                                    v =>
                                                                        !!v ||
                                                                        'Required',
                                                                    v =>
                                                                        (!isNaN(
                                                                            parseFloat(
                                                                                v
                                                                            )
                                                                        ) &&
                                                                            v >=
                                                                                0) ||
                                                                        'Only numbers'
                                                                ]"
                                                                required
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col md="4">
                                                            <v-text-field
                                                                v-model="
                                                                    editedItem.total
                                                                "
                                                                label="Total"
                                                                :rules="[
                                                                    v =>
                                                                        !!v ||
                                                                        'Required',
                                                                    v =>
                                                                        (!isNaN(
                                                                            parseFloat(
                                                                                v
                                                                            )
                                                                        ) &&
                                                                            v >=
                                                                                0) ||
                                                                        'Only numbers'
                                                                ]"
                                                                required
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="4">
                                                            <v-combobox
                                                                placeholder="Select province"
                                                                class="mx-3"
                                                                v-model="
                                                                    editedItem.Province
                                                                "
                                                                :items="
                                                                    provinces
                                                                "
                                                                required
                                                                :rules="[
                                                                    v =>
                                                                        !!v ||
                                                                        'Required'
                                                                ]"
                                                                :item-text="
                                                                    'Province'
                                                                "
                                                                :item-value="
                                                                    'ProvinceAbbr'
                                                                "
                                                                auto-select-first
                                                            >
                                                            </v-combobox>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-text-field
                                                                v-model="
                                                                    editedItem.actualPrice
                                                                "
                                                                label="Actual Price"
                                                                :rules="[
                                                                    v =>
                                                                        !!v ||
                                                                        'Required',
                                                                    v =>
                                                                        (!isNaN(
                                                                            parseFloat(
                                                                                v
                                                                            )
                                                                        ) &&
                                                                            v >=
                                                                                0) ||
                                                                        'Only numbers'
                                                                ]"
                                                                required
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-text-field
                                                                v-model="
                                                                    editedItem.actualCost
                                                                "
                                                                label="Actual Cost"
                                                                :rules="[
                                                                    v =>
                                                                        !!v ||
                                                                        'Required',
                                                                    v =>
                                                                        (!isNaN(
                                                                            parseFloat(
                                                                                v
                                                                            )
                                                                        ) &&
                                                                            v >=
                                                                                0) ||
                                                                        'Only numbers'
                                                                ]"
                                                                required
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-form>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="close"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="validateFormEdit()"
                                            >
                                                Save
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <!-- delete entry dialog -->
                                <v-dialog
                                    v-model="dialogDelete"
                                    max-width="510px"
                                >
                                    <v-card>
                                        <v-card-title class="headline"
                                            >Are you sure you want to delete
                                            this entry?</v-card-title
                                        >
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeDelete"
                                                >Cancel</v-btn
                                            >
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="deleteItemConfirm"
                                                >OK</v-btn
                                            >
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <!-- continue expenses entries table -->
                        <template v-slot:item.Date="{ item }">
                            {{ item.Date }}
                        </template>
                        <template v-slot:item.Supplier="{ item }">
                            <v-combobox
                                v-if="item.Supplier == null"
                                v-model="item.SuppCom"
                                :items="suppliers"
                                :item-text="'Supplier'"
                                :item-value="'OOSupplierId'"
                                dense
                                @change="assingSupplier(item)"
                                hide-details
                            ></v-combobox>
                            <td v-else>{{ item.Supplier }}</td>
                        </template>
                        <template v-slot:item.ShiftDetail="{ item }">
                            {{ item.text }}
                        </template>
                        <template v-slot:item.expenseType="{ item }">
                            {{ item.expenseType.Type }}
                        </template>
                        <template v-slot:item.Province="{ item }">
                            {{
                                item.Province == null
                                    ? ''
                                    : item.Province.Province === undefined
                                    ? item.Province
                                    : item.Province.ProvinceAbbr
                            }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="editItem(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small @click="deleteEntry(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </template>
            </v-container>
            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
export default {
    name: 'FuelExpensesEntries',
    directives: {
        mask
    },
    components: {
        ConfirmDialogue
    },
    data: function() {
        return {
            comboboxSupplier: '',
            suppliers: [],
            shifts: [],
            date: '',
            fuelType: [],
            stDate: '',
            valid: false,
            province: '',
            dialog: false,
            dialogDelete: false,
            editedIndex: -1,
            editedItem: {
                shifts: {
                    ShiftDetail: '',
                    driver: '',
                    shift_header: '',
                    truck: ''
                },
                invoiceNo: '',
                expenseType: '',
                qty: '',
                gst: '',
                total: '',
                actualPrice: '',
                actualCost: ''
            },
            defaultItem: {
                shifts: {
                    ShiftDetail: '',
                    driver: '',
                    shift_header: '',
                    truck: ''
                },
                invoiceNo: '',
                expenseType: '',
                qty: '',
                actualPrice: '',
                actualCost: ''
            },
            stNumber: '',
            provinces: [],
            comboShifts: '',
            invoiceNo: '',
            expenseType: '',
            qty: '',
            gst: '',
            total: '',
            actualPrice: '',
            actualCost: '',
            OOExpId: '',
            dateRules: [
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            titles: [
                { text: 'Shift', value: 'shifts', width: '30%' },
                { text: 'Trs. Date', value: 'Date', width: '11%' },
                { text: 'Invoice No.', value: 'invoiceNo', width: '8%' },

                { text: 'Expense Type', value: 'expenseType', width: '11%' },

                { text: 'QTY', value: 'qty', width: '8%' },
                { text: 'GST', value: 'gst', width: '5%' },
                { text: 'Total', value: 'total', width: '5%' },
                { text: 'Province', value: 'Province.Province', width: '12%' },

                { text: 'Actual Price', value: 'actualPrice', width: '6%' },
                { text: 'Actual Cost', value: 'actualCost', width: '7%' },
                { text: 'Actions', value: 'actions', width: '6%' }
            ],
            titleEntrys: [
                { text: 'Shift', value: 'ShiftDetail', width: '30%' },
                { text: 'Stmt PayId', value: 'Stid', width: '5%' },
                { text: 'Supplier', value: 'Supplier', width: '15%' },
                { text: 'Date', value: 'Date', width: '11%' },
                { text: 'Invoice No.', value: 'invoiceNo', width: '8%' },
                { text: 'Expense Type', value: 'expenseType', width: '5%' },
                { text: 'QTY', value: 'qty', width: '8%' },
                { text: 'GST', value: 'gst', width: '5%' },
                { text: 'Total', value: 'total', width: '5%' },
                { text: 'Province', value: 'Province', width: '15%' },

                { text: 'Actual Price', value: 'actualPrice', width: '5%' },
                { text: 'Actual Cost', value: 'actualCost', width: '5%' },
                { text: 'Actions', value: 'actions', width: '6%' }
                // { text: 'delete', value: 'delete', width: '6%' }
            ],
            expensesEntries: [
                {
                    shifts: {
                        ShiftDetail: '',
                        driver: '',
                        shift_header: '',
                        truck: ''
                    },
                    text: '',
                    invoiceNo: '',
                    expenseType: '',
                    qty: '',
                    gst: '',
                    total: '',
                    actualPrice: '',
                    actualCost: '',
                    actions: ''
                }
            ],
            data: [],
            dataLoading: true
        };
    },
    mounted() {
        this.loadRegisteredExpenses();
        this.loadSuppliers();
        this.loadShifts();
        this.loadProvinces();
        this.loadFuelType();
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        }
    },
    methods: {
        async deleteEntry(item) {
            var str = this.$store;
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this entry',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                console.log(item);
                str.state.isLoading = true;
                axios
                    .delete('fuel-expense/' + item.OOExpId, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        const idx = this.data.findIndex(x => {
                            return x.OOExpId == item.OOExpId;
                        });
                        console.log(idx);
                        this.data.splice(idx, 1);
                        str.state.isLoading = false;
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Entry deleted'
                        });
                    })
                    .catch(error => {
                        str.state.isLoading = false;
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                        console.log(error);
                    });
            }
        },
        viewDta: function() {
            console.log(this.comboShifts);
        },

        calculateEdt: function() {
            this.editedItem.gst = Number(
                this.editedItem.qty * 0.54 * 0.13
            ).toFixed(2);

            this.editedItem.total = Number(
                this.editedItem.qty * 0.54 * 1.13
            ).toFixed(2);
        },
        calculate: function() {
            this.gst = Number(this.qty * 0.54 * 0.13).toFixed(2);

            this.total = Number(this.qty * 0.54 * 1.13).toFixed(2);
        },
        loadSuppliers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('fuel-supplier')
                .then(response => {
                    console.log(response.data);
                    this.suppliers = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        loadProvinces: function() {
            this.$store.state.isLoading = true;
            axios
                .get('province')
                .then(response => {
                    console.log(response.data);
                    this.provinces = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        setDate: function() {
            this.date = this.stDate;
        },
        loadShifts: function() {
            this.$store.state.isLoading = true;
            axios
                .get(
                    'shift-detail/dates-fuel/' +
                        this.$store.state.expensesEntries.start_date +
                        '/' +
                        this.$store.state.expensesEntries.end_date,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    this.$store.state.isLoading = false;
                    console.log(response.data);
                    this.shifts = response.data;
                    this.shifts.forEach(element => {
                        element.text =
                            element.shift_header.Date +
                            ' ' +
                            element.shift_header.Shift +
                            ' - ' +
                            element.driver.Name +
                            ' - ' +
                            element.truck.Truck;
                    });
                    this.expensesEntries.shifts = response.data;
                    console.log(this.expensesEntries, this.shifts);
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        loadRegisteredExpenses: function() {
            this.$store.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.expensesEntries.start_date,
                EndDate: this.$store.state.expensesEntries.end_date
            };
            axios
                .post('fuel-expense/expenses/entries', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.data = response.data;
                    this.data.forEach(elm => {
                        const id = this.fuelType.findIndex(x => {
                            return x.OOExpTypeId == elm.expenseType;
                        });
                        elm.expenseType = this.fuelType[id];
                    });
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        loadFuelType: function() {
            this.$store.state.isLoading = true;
            axios
                .get('fuel-expense-type/filter')
                .then(response => {
                    this.$store.state.isLoading = false;
                    console.log(response.data);
                    this.fuelType = response.data;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },

        resetVariables: function() {
            this.comboShifts = [];
            this.province = [];
            this.expenseType = [];
            this.gst = null;
            this.total = null;
            this.qty = null;
            this.actualCost = null;
            this.actualPrice = null;
            this.invoiceNo = null;
        },
        addFuelExpenseEntry() {
            //TODO enviar parametros correctos y auth
            this.$store.state.isLoading = true;
            var params = {
                Supplier: this.comboboxSupplier.OOSupplierId,
                ShiftDetail: this.comboShifts.ShiftDetail,
                TruckId: this.comboShifts.truck.TruckID,
                Type: this.expenseType.OOExpTypeId,
                GST: this.gst,
                total: this.total,
                Qty: this.qty,
                Province: this.province.ProvinceAbbr,
                InvoiceNo: this.invoiceNo,
                ActualCost: this.actualCost,
                ActualPrice: this.actualPrice,
                SupplierInvoiceDate: this.stDate,
                SuppInvNo: this.stNumber,
                Date: this.date
            };
            axios
                .post('fuel-expense', params)
                .then(response => {
                    console.log(response.data);
                    var entry = {
                        shifts: {
                            ShiftDetail: this.comboShifts.ShiftDetail,
                            driver: this.comboShifts.driver,
                            shift_header: this.comboShifts.shift_header,
                            truck: this.comboShifts.truck
                        },
                        Date: this.date,
                        ShiftDetail: this.comboShifts.ShiftDetail,
                        text: this.comboShifts.text,
                        OOExpId: response.data.OOExpId,
                        invoiceNo: this.invoiceNo,
                        TruckID: this.comboShifts.truck.TruckID,
                        Province: this.province,
                        expenseType: this.expenseType,
                        Supplier: this.comboboxSupplier.Supplier,
                        qty: this.qty,
                        gst: this.gst,
                        total: this.total,
                        actualPrice: this.actualPrice,
                        actualCost: this.actualCost
                    };
                    console.log(entry);
                    this.data.push(entry);
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'New entry added.'
                    });
                    this.resetVariables();
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    console.log(error);
                });
        },
        validateFormAdd() {
            if (this.$refs.formAdd.validate()) {
                this.addFuelExpenseEntry();
            }
        },
        validateFormEdit() {
            if (this.$refs.formEdit.validate()) {
                this.editEntry();
                console.log(this.editedItem);
            }
        },
        editItem(item) {
            this.OOExpId = item.OOExpId;
            console.log(item);
            this.editedIndex = this.data.indexOf(item);
            this.editedItem = Object.assign({}, item);
            console.log(Object.assign({}, item));
            this.dialog = true;
        },
        deleteItem(item) {
            this.OOExpId = item.OOExpId;
            this.editedIndex = this.data.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },
        deleteItemConfirm() {
            this.$store.state.isLoading = true;
            //TODO editar peticion para eliminar
            axios
                .delete('fuel-expense/' + this.OOExpId)
                .then(response => {
                    console.log(response.data);

                    this.data.splice(this.editedIndex, 1);

                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Entry deleted'
                    });
                    this.closeDelete();
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    console.log(error);
                });
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        changeShift: function() {
            this.editedItem.ShiftDetail = this.editedItem.text.ShiftDetail;
            this.editedItem.TruckID = this.editedItem.text.truck.TruckID;
            this.editedItem.text =
                this.editedItem.text.shift_header.Date +
                ' - ' +
                this.editedItem.text.driver.Name +
                ' - ' +
                this.editedItem.text.truck.Truck;
            console.log(this.editedItem);
        },
        assingSupplier: function(itm) {
            console.log(itm);
            var parms = {
                Supplier: itm.SuppCom.OOSupplierId
            };
            var str = this.$store;
            str.state.isLoading = true;
            console.log(parms);
            axios
                .put('fuel-expense/' + itm.OOExpId, parms)
                .then(response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                    itm.SupplierId = itm.SuppCom.SupplierId;
                    itm.Supplier = itm.SuppCom.Supplier;
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Update Supplier Entry '
                    });
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    console.log(error);
                });
        },

        editEntry() {
            this.$store.state.isLoading = true;
            //TODO editar peticion para editar
            console.log(this.editedItem);
            var params = {
                ShiftDetail: this.editedItem.ShiftDetail,
                TruckId: this.editedItem.TruckID,
                Type: this.editedItem.expenseType.OOExpTypeId,
                GST: this.editedItem.gst,
                total: this.editedItem.total,
                Qty: this.editedItem.qty,
                InvoiceNo: this.editedItem.invoiceNo,
                ActualCost: this.editedItem.actualCost,
                ActualPrice: this.editedItem.actualPrice,
                Date: this.editedItem.Date,
                Province: this.editedItem.Province.ProvinceAbbr
            };
            console.log(params);
            axios
                .put('fuel-expense/' + this.OOExpId, params)
                .then(response => {
                    console.log(response.data);
                    Object.assign(this.data[this.editedIndex], this.editedItem);

                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Entry edited.'
                    });
                    this.close();
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    console.log(error);
                });
        }
    }
};
</script>
